import { Fragment } from "react";
import { NavLink } from "react-router-dom";
import aboutus from "../../assets/images/landing/aboutus.png";
import "./AboutSection.css";

const AboutSection = () => {
  return (
    <Fragment>
      <section className="about-section">
        <div className="container">
          <div
            className="section-title"
            data-aos="fade-down"
            data-aos-duration="800"
          >
            <div className="text-uppercase">About</div>
            <h4 className="text-uppercase">Learn more about us</h4>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="aboutus-image">
                <img
                  src={aboutus}
                  loading="lazy"
                  alt="image not found"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="aboutus-desc">
                <h2
                  data-aos="fade-down"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  We're Serving Innovation for Your Business
                </h2>
                <p
                  data-aos="fade-left"
                  data-aos-delay="200"
                  data-aos-duration="800"
                >
                  We are professionals in blockchain development, mobile app
                  development, and web development. Our specialists have a
                  wealth of knowledge in developing web applications using the
                  most recent technologies. We build custom applications to
                  enhance your business and help you stay ahead of the
                  competition.
                </p>
                <div className="mt-35">
                  <div className="about-btn-fill">
                    <NavLink to="/about"><span>Learn More</span></NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default AboutSection;
